const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

let environment;

switch (env) {
  case 'prod':
    environment = require('./environment.prod').environment;
    break;
  case 'stg':
    environment = require('./environment.stg').environment;
    break;
  case 'uat':
    environment = require('./environment.uat').environment;
    break;
  case 'dev':
  default:
    environment = require('./environment.dev').environment;
    break;
}

export { environment };